import { HttpClient as AngularHttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';

@Injectable()
export class RevisionContextHttpClient extends HttpClient {

  constructor(public http: AngularHttpClient) {
    super(http);
  }
}
